module.exports = __webpack_public_path__ + "static/media/signal_head_red.6eb5bc6e.glb";